function searchToggle() {
  const searchToggle = document.querySelector("#js-search-toggle");
  const searchContainer = document.querySelector("#search-container");
  searchToggle.addEventListener("click", function () {
    searchContainer.classList.toggle("dn");
  });
}

export { searchToggle };
